import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Badge,
  Typography,
} from "@material-ui/core";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import NotificationsIcon from "@material-ui/icons/Notifications";
import AttachMoney from "@material-ui/icons/AttachMoney";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import MySpaIcon from "@material-ui/icons/Home";
import ProfileIcon from "@material-ui/icons/InfoRounded";
import BookingIcon from "@material-ui/icons/Layers";
import PostIcon from "@material-ui/icons/BorderColorRounded";
import MenuIcon from "@material-ui/icons/LibraryBooks";
import VoucherIcon from "@material-ui/icons/LocalPlayRounded";
import UserVoucherIcon from "@material-ui/icons/Send";
import MoodIcon from "@material-ui/icons/Mood";
import CustomerIcon from "@material-ui/icons/People";
import MemberCardIcon from "@material-ui/icons/CardMembership";
import EmployeeIcon from "@material-ui/icons/PersonPin";
import OrderIcon from "@material-ui/icons/ArchiveRounded";
import DiscountIcon from "@material-ui/icons/StyleRounded";
import ReportIcon from "@material-ui/icons/Receipt";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import FiberDvrIcon from "@material-ui/icons/FiberDvr";
import SmsIcon from "@material-ui/icons/Sms";
import { styles } from "./styles";

class Spa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openCollapse: {
        mySpa: false,
        promotion: false,
        cms: false,
        product_menu: false,
      },
      selected: this.props.selected,
    };
  }
  componentDidMount() {
    let { moduleRole } = this.props;
    this.props.onRef(this);
    this.setState({ selected: this.props.selected });
    if (moduleRole && moduleRole.adminBooking && moduleRole.adminBooking.view)
      this.props.bookingDispatch.totalBookingChecking();
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selected !== this.props.selected &&
      nextProps.selected !== this.state.selected
    ) {
      this.setState({ selected: nextProps.selected });
    }
  }
  handleSelect = (value = "") => {
    if (value !== this.state.selected) this.setState({ selected: value });
  };
  handleClick = (name) => () => {
    let { openCollapse } = this.state;
    openCollapse[name] = !openCollapse[name];
    this.setState(openCollapse);
  };

  render() {
    const {
      classes,
      t,
      moduleRole,
      open,
      listPluginsService = [],
    } = this.props;
    const { selected, openCollapse = [] } = this.state;
    if (moduleRole) {
      return (
        <div className={classes.rootSidebar}>
          <span
            className={classNames(
              classes.section,
              !open && classes.hideSection
            )}
          >
            {t("sidebar_manage")}
          </span>
          <List>
            {moduleRole.dashboard && moduleRole.dashboard.active ? (
              <Link to="/">
                <ListItem
                  className={classes.listItem}
                  button
                  selected={selected === ""}
                  onClick={() => this.handleSelect("")}
                >
                  <ListItemIcon className={classes.icon}>
                    <DashboardIcon />
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_dashboard")}
                    </Typography>
                  </ListItemText>
                </ListItem>
              </Link>
            ) : (
              ""
            )}

            {(moduleRole.menuService && moduleRole.menuService.view) ||
              (moduleRole.service && moduleRole.service.view) ||
              (moduleRole.branch && moduleRole.branch.view) ||
              (moduleRole.album && moduleRole.album.view) ||
              (moduleRole.storage && moduleRole.storage.view) ? (
              <div>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={this.handleClick("mySpa")}
                >
                  <ListItemIcon className={classes.icon}>
                    <MySpaIcon />
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_my_spa")}
                    </Typography>
                  </ListItemText>
                  {openCollapse.mySpa ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openCollapse.mySpa}>
                  <List component="div" disablePadding>
                    {moduleRole.service && moduleRole.service.view && open ? (
                      <Link to="/service/detail">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "service_detail"}
                          onClick={() => this.handleSelect("service_detail")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_detail")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )}

                    {moduleRole.branch && moduleRole.branch.view && open ? (
                      <Link to="/service/branch">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "service_branch"}
                          onClick={() => this.handleSelect("service_branch")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_branch")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )}

                    {moduleRole.album && moduleRole.album.view && open ? (
                      <Link to="/service/album">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "service_album"}
                          onClick={() => this.handleSelect("service_album")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_album")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )}
                    {/* {moduleRole.storage && moduleRole.storage.view && open ? (
                      <Link to="/service/storage">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "service_storage"}
                          onClick={() => this.handleSelect("service_storage")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_storage")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )} */}
                    {open ? (
                      <Link to="/service/payment">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "service_payment"}
                          onClick={() => this.handleSelect("service_payment")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_service_payment")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )}
                    {open ? (
                      <Link to="/module">
                        <ListItem
                          className={classes.nested}
                          selected={selected === "module"}
                          onClick={() => this.handleSelect("module")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_module")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )}
                  </List>
                </Collapse>
              </div>
            ) : (
              ""
            )}

            {moduleRole.adminBooking && moduleRole.adminBooking.view ? (
              <Link to="/booking">
                <ListItem
                  className={classes.listItem}
                  button
                  selected={selected === "booking"}
                  onClick={() => this.handleSelect("booking")}
                >
                  <ListItemIcon className={classes.icon}>
                    <Badge
                      color="secondary"
                      badgeContent={this.props.totalBookingChecking}
                      anchorOrigin={{
                        horizontal: "left",
                        vertical: "top",
                      }}
                      className={classes.margin}
                    >
                      <BookingIcon />
                    </Badge>
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_booking")}
                    </Typography>
                  </ListItemText>
                </ListItem>
              </Link>
            ) : (
              ""
            )}
            {moduleRole.adminOrder && moduleRole.adminOrder.view ? (
              <Link to="/order/list">
                <ListItem
                  className={classes.listItem}
                  button
                  selected={selected === "order"}
                  onClick={() => this.handleSelect("order")}
                >
                  <ListItemIcon className={classes.icon}>
                    <OrderIcon />
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_order")}
                    </Typography>
                  </ListItemText>
                </ListItem>
              </Link>
            ) : (
              ""
            )}

            {moduleRole.customer && moduleRole.customer.view ? (
              <Link to="/customer">
                <ListItem
                  className={classes.listItem}
                  button
                  selected={selected === "customer"}
                  onClick={() => this.handleSelect("customer")}
                >
                  <ListItemIcon className={classes.icon}>
                    <CustomerIcon />
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_customer")}
                    </Typography>
                  </ListItemText>
                </ListItem>
              </Link>
            ) : (
              ""
            )}

            {moduleRole.employeeSystem && moduleRole.employeeSystem.view ? (
              <Link to="/employee">
                <ListItem
                  className={classes.listItem}
                  button
                  selected={selected === "employee"}
                  onClick={() => this.handleSelect("employee")}
                >
                  <ListItemIcon className={classes.icon}>
                    <EmployeeIcon />
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_employee")}
                    </Typography>
                  </ListItemText>
                </ListItem>
              </Link>
            ) : (
              ""
            )}

            {moduleRole.cost && moduleRole.cost.view === 1 ? (
              <div>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={this.handleClick("serviceCost")}
                >
                  <ListItemIcon className={classes.icon}>
                    <AttachMoney />
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_cost")}
                    </Typography>
                  </ListItemText>
                  {openCollapse.serviceCost ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openCollapse.serviceCost}>
                  <List component="div" disablePadding>
                    {/* {moduleRole.stableCost.view  &&  */}
                    {open && (
                      <Link to="/service/stableCost">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "service_stable_cost"}
                          onClick={() =>
                            this.handleSelect("service_stable_cost")
                          }
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_stableCost")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    )}
                    {/* } */}
                    {/* {moduleRole.stableCost.view  &&  */}
                    {open ? (
                      <Link to="/service/cost">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "service_cost"}
                          onClick={() => this.handleSelect("service_cost")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_service_cost")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )}
                    {/* } */}
                  </List>
                </Collapse>
              </div>
            ) : (
              ""
            )}
            {moduleRole.report && moduleRole.report.view === 1 ? (
              <Link to="/report">
                <ListItem
                  className={classes.listItem}
                  button
                  selected={selected === "report"}
                  onClick={() => this.handleSelect("report")}
                >
                  <ListItemIcon className={classes.icon}>
                    <ReportIcon />
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_report")}
                    </Typography>
                  </ListItemText>
                </ListItem>
              </Link>
            ) : (
              ""
            )}
            {moduleRole.sms && moduleRole.sms.view === 1 ? (
              <Link to="/sms">
                <ListItem
                  className={classes.listItem}
                  button
                  selected={selected === "sms"}
                  onClick={() => this.handleSelect("sms")}
                >
                  <ListItemIcon className={classes.icon}>
                    <SmsIcon />
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_sms")}
                    </Typography>
                  </ListItemText>
                </ListItem>
              </Link>
            ) : (
              ""
            )}
            <Link to="/profile">
              <ListItem
                className={classes.listItem}
                button
                selected={selected === "profile"}
                onClick={() => this.handleSelect("profile")}
              >
                <ListItemIcon className={classes.icon}>
                  <ProfileIcon />
                </ListItemIcon>
                <ListItemText
                  className={classNames(
                    classes.listItemText,
                    !open && classes.listItemTextSidebarClose
                  )}
                >
                  <Typography variant="body1" className={classes.item}>
                    {t("sidebar_profile")}
                  </Typography>
                </ListItemText>
              </ListItem>
            </Link>
            <Link to="/notification">
              <ListItem
                className={classes.listItem}
                button
                selected={selected === "notification"}
                onClick={() => this.handleSelect("notification")}
              >
                <ListItemIcon className={classes.icon}>
                  <NotificationsIcon />
                </ListItemIcon>
                <ListItemText
                  className={classNames(
                    classes.listItemText,
                    !open && classes.listItemTextSidebarClose
                  )}
                >
                  <Typography variant="body1" className={classes.item}>
                    {t("sidebar_notification")}
                  </Typography>
                </ListItemText>
              </ListItem>
            </Link>
          </List>
          {moduleRole.menuService && moduleRole.menuService.view && open ? (
            <>
              <span
                className={classNames(
                  classes.section,
                  !open && classes.hideSection
                )}
              >
                {t("sidebar_service_and_product")}
              </span>
              <List>
                <Link to="/serviceMenu">
                  <ListItem
                    className={classes.listItem}
                    button
                    selected={selected === "service_menu"}
                    onClick={() => this.handleSelect("service_menu")}
                  >
                    <ListItemIcon className={classes.icon}>
                      <MenuIcon />
                    </ListItemIcon>
                    <ListItemText className={classes.listItemText}>
                      <Typography variant="body1" className={classes.item}>
                        {t("sidebar_menu")}
                      </Typography>
                    </ListItemText>
                  </ListItem>
                </Link>
                <div>
                  <ListItem
                    className={classes.listItem}
                    button
                    onClick={this.handleClick("product_menu")}
                  >
                    <ListItemIcon className={classes.icon}>
                      <LocalMallIcon />
                    </ListItemIcon>
                    <ListItemText className={classes.listItemText}>
                      <Typography variant="body1" className={classes.item}>
                        {t("sidebar_product")}
                      </Typography>
                    </ListItemText>
                    {openCollapse.product_menu ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItem>
                  <Collapse in={openCollapse.product_menu}>
                    <List component="div" disablePadding>
                      <Link to="/productMenu/list">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "product_list"}
                          onClick={() => this.handleSelect("product_list")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_list_product")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                      <Link to="/productMenu/create">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "product_create"}
                          onClick={() => this.handleSelect("product_create")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_create_product")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    </List>
                  </Collapse>
                </div>
              </List>
            </>
          ) : (
            ""
          )}
          <span
            className={classNames(
              classes.section,
              !open && classes.hideSection
            )}
          >
            {t("sidebar_cms")}
          </span>
          <List>
            {(moduleRole.post && moduleRole.post.view) ||
              (moduleRole.contact && moduleRole.contact.view) ||
              (moduleRole.visitor && moduleRole.visitor.view) ? (
              <div>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={this.handleClick("cms")}
                >
                  <ListItemIcon className={classes.icon}>
                    <PostIcon />
                  </ListItemIcon>
                  <ListItemText
                    className={classNames(
                      classes.listItemText,
                      !open && classes.listItemTextSidebarClose
                    )}
                  >
                    <Typography variant="body1" className={classes.item}>
                      {t("sidebar_cms")}
                    </Typography>
                  </ListItemText>
                  {openCollapse.cms ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openCollapse.cms}>
                  <List component="div" disablePadding>
                    {moduleRole.post && moduleRole.post.view && open
                      ? [
                        moduleRole.post.insert ? (
                          <Link to="/post/create" key={"row" + Math.random()}>
                            <ListItem
                              className={classes.nested}
                              button
                              selected={selected === "post_create"}
                              onClick={() => this.handleSelect("post_create")}
                            >
                              <ListItemText className={classes.listItemText}>
                                <Typography
                                  variant="body1"
                                  className={classes.item}
                                >
                                  {t("sidebar_post_create")}
                                </Typography>
                              </ListItemText>
                            </ListItem>
                          </Link>
                        ) : (
                          ""
                        ),
                        moduleRole.post.view ? (
                          <Link to="/post/list" key={"row" + Math.random()}>
                            <ListItem
                              className={classes.nested}
                              button
                              selected={selected === "post_list"}
                              onClick={() => this.handleSelect("post_list")}
                            >
                              <ListItemText className={classes.listItemText}>
                                <Typography
                                  variant="body1"
                                  className={classes.item}
                                >
                                  {t("sidebar_post_list")}
                                </Typography>
                              </ListItemText>
                            </ListItem>
                          </Link>
                        ) : (
                          ""
                        ),
                      ]
                      : ""}
                    {moduleRole.contact && moduleRole.contact.view && open
                      ? [
                        <Link to="/contact/list" key={"row" + Math.random()}>
                          <ListItem
                            className={classes.nested}
                            button
                            selected={selected === "contact_list"}
                            onClick={() => this.handleSelect("contact_list")}
                          >
                            <ListItemText className={classes.listItemText}>
                              <Typography
                                variant="body1"
                                className={classes.item}
                              >
                                {t("sidebar_contact")}
                              </Typography>
                            </ListItemText>
                          </ListItem>
                        </Link>,
                      ]
                      : ""}
                    {/* {(moduleRole.contact && moduleRole.contact.view) ?    */}
                    {open ? (
                      <Link to="/campaign">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "campaign"}
                          onClick={() => this.handleSelect("campaign")}
                        >
                          <ListItemText>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_campaign")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )}
                    {/* : ""} */}
                    {moduleRole.visitor && moduleRole.visitor.view && open ? (
                      <Link to="/visitor/list">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "visitor"}
                          onClick={() => this.handleSelect("visitor")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("sidebar_visitor")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )}
                    {moduleRole.customerFeedback &&
                      moduleRole.customerFeedback.view &&
                      open ? (
                      <Link to="/customerFeedback">
                        <ListItem
                          className={classes.nested}
                          button
                          selected={selected === "customerFeedback"}
                          onClick={() => this.handleSelect("customerFeedback")}
                        >
                          <ListItemText className={classes.listItemText}>
                            <Typography
                              variant="body1"
                              className={classes.item}
                            >
                              {t("customer_feedback")}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </Link>
                    ) : (
                      ""
                    )}
                  </List>
                </Collapse>
              </div>
            ) : (
              ""
            )}
            <Link to="/nps">
              <ListItem
                className={classes.listItem}
                button
                selected={selected === "nps"}
                onClick={() => this.handleSelect("nps")}
              >
                <ListItemIcon className={classes.icon}>
                  <MoodIcon />
                </ListItemIcon>
                <ListItemText
                  className={classNames(
                    classes.listItemText,
                    !open && classes.listItemTextSidebarClose
                  )}
                >
                  <Typography variant="body1" className={classes.item}>
                    {t("sidebar_nps")}
                  </Typography>
                </ListItemText>
              </ListItem>
            </Link>
            <Link to="/digital/list">
              <ListItem
                className={classes.listItem}
                button
                selected={selected === "digital"}
                onClick={() => this.handleSelect("digital")}
              >
                <ListItemIcon className={classes.icon}>
                  <FiberDvrIcon />
                </ListItemIcon>
                <ListItemText
                  className={classNames(
                    classes.listItemText,
                    !open && classes.listItemTextSidebarClose
                  )}
                >
                  <Typography variant="body1" className={classes.item}>
                    {t("sidebar_digital_signal")}
                  </Typography>
                </ListItemText>
              </ListItem>
            </Link>
          </List>
          {(moduleRole.voucher && moduleRole.voucher.view) ||
            (moduleRole.discount && moduleRole.discount.view) ||
            (moduleRole.memberCard && moduleRole.memberCard.view) ? (
            <>
              <span
                className={classNames(
                  classes.section,
                  !open && classes.hideSection
                )}
              >
                {t("sidebar_promotion")}
              </span>
              <List component="div">
                {moduleRole.voucher && moduleRole.voucher.view ? (
                  <Link to="/promotion/voucher">
                    <ListItem
                      className={classes.listItem}
                      button
                      selected={selected === "promotion_voucher"}
                      onClick={() => this.handleSelect("promotion_voucher")}
                    >
                      <ListItemIcon className={classes.icon}>
                        <VoucherIcon />
                      </ListItemIcon>
                      <ListItemText
                        className={classNames(
                          classes.listItemText,
                          !open && classes.listItemTextSidebarClose
                        )}
                      >
                        <Typography variant="body1" className={classes.item}>
                          {t("sidebar_voucher")}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </Link>
                ) : (
                  ""
                )}
                {moduleRole.voucher && moduleRole.voucher.view ? (
                  <Link to="/promotion/userVoucher">
                    <ListItem
                      className={classes.listItem}
                      button
                      selected={selected === "promotion_userVoucher"}
                      onClick={() => this.handleSelect("promotion_userVoucher")}
                    >
                      <ListItemIcon className={classes.icon}>
                        <UserVoucherIcon />
                      </ListItemIcon>
                      <ListItemText
                        className={classNames(
                          classes.listItemText,
                          !open && classes.listItemTextSidebarClose
                        )}
                      >
                        <Typography variant="body1" className={classes.item}>
                          {t("sidebar_user_voucher")}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </Link>
                ) : (
                  ""
                )}
                {moduleRole.discount && moduleRole.discount.view ? (
                  <Link to="/promotion/discount">
                    <ListItem
                      className={classes.listItem}
                      button
                      selected={selected === "promotion_discount"}
                      onClick={() => this.handleSelect("promotion_discount")}
                    >
                      <ListItemIcon className={classes.icon}>
                        <DiscountIcon />
                      </ListItemIcon>
                      <ListItemText
                        className={classNames(
                          classes.listItemText,
                          !open && classes.listItemTextSidebarClose
                        )}
                      >
                        <Typography variant="body1" className={classes.item}>
                          {t("sidebar_discount")}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </Link>
                ) : (
                  ""
                )}
                {moduleRole.memberCard && moduleRole.memberCard.view ? (
                  <Link to="/promotion/membercard">
                    <ListItem
                      className={classes.listItem}
                      button
                      selected={selected === "membercard"}
                      onClick={() => this.handleSelect("membercard")}
                    >
                      <ListItemIcon className={classes.icon}>
                        <MemberCardIcon />
                      </ListItemIcon>
                      <ListItemText
                        className={classNames(
                          classes.listItemText,
                          !open && classes.listItemTextSidebarClose
                        )}
                      >
                        <Typography variant="body1" className={classes.item}>
                          {t("sidebar_membercard")}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </Link>
                ) : (
                  ""
                )}
                {moduleRole.memberCard && moduleRole.memberCard.view ? (
                  <Link to="/promotion/userMembercard/list">
                    <ListItem
                      className={classes.listItem}
                      button
                      selected={selected === "userMembercard"}
                      onClick={() => this.handleSelect("userMembercard")}
                    >
                      <ListItemIcon className={classes.icon}>
                        <UserVoucherIcon />
                      </ListItemIcon>
                      <ListItemText
                        className={classNames(
                          classes.listItemText,
                          !open && classes.listItemTextSidebarClose
                        )}
                      >
                        <Typography variant="body1" className={classes.item}>
                          {t("sidebar_user_membercard")}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </Link>
                ) : (
                  ""
                )}
              </List>
            </>
          ) : (
            ""
          )}
          <span
            className={classNames(
              classes.section,
              !open && classes.hideSection
            )}
          >
            {t("Plugin")}
          </span>
          <List>
            {listPluginsService.map((plugin, index) => {
              if (plugin.pluginKey !== undefined) {
                return (
                  <Link key={index} to={`/myPlugin/${plugin.pluginKey}`}>
                    <ListItem
                      className={classes.listItem}
                      button
                      selected={selected === plugin.pluginKey}
                      onClick={() => this.handleSelect(plugin.pluginKey)}
                    >
                      <img
                        className={classes.iconPlugin}
                        src={plugin.pluginIcon || "/images/noneImage.svg"}
                      />
                      <ListItemText className={classes.listItemText}>
                        <Typography variant="body1" className={classes.item}>
                          {plugin.pluginName}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </Link>
                );
              }
              return "";
            })}
            <Link to="/pluginCategory">
              <ListItem
                className={classes.listItem}
                button
                selected={selected === "pluginCategory"}
                onClick={() => this.handleSelect("pluginCategory")}
              >
                <ListItemIcon className={classes.icon}>
                  <ShoppingCartIcon />
                </ListItemIcon>
                <ListItemText className={classes.listItemText}>
                  <Typography variant="body1" className={classes.item}>
                    {t("Power Ups")}
                  </Typography>
                </ListItemText>
              </ListItem>
            </Link>
          </List>
        </div>
      );
    } else {
      return "";
    }
  }
}

Spa.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  isRead: state.serviceContacts.isRead,
  role: state.user.user.roleId.role,
  totalBookingChecking: state.booking.totalBookingChecking,
  listPluginsService: state.pluginServices.listPlugins,
});

const mapDispatch = (dispatch) => ({
  getListContact: dispatch.serviceContacts.getList,
  bookingDispatch: dispatch.booking,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Spa)));
